
const ENV_TEST = 'test';
const ENV_PRE = 'prerelease';
const ENV_PROD = 'prod';
let currentEnv = 'test';
if (typeof window !== 'undefined' && window.CEIBA_ENV) {
  currentEnv = window.CEIBA_ENV;
}
const env = {
  env: currentEnv,
  isTest: currentEnv === ENV_TEST,
  isPre: currentEnv === ENV_PRE,
  isProd: currentEnv === ENV_PROD,
};
export default env;
